import { FC } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { Grid, Tooltip } from '@mui/material';
import { SCUICustomDataGrid } from '../../../../../atomic/molecules';
import TimeHelper from '../../../../../utils/time';
import { SCUILoading } from '../../../../../atomic/atoms';
import Helper from '../../../../../utils/helper';

export const SCUIRefundDetailCustomerInfo: FC<{
    paymentResult?: any;
    currencySymbol?: any;
}> = ({ paymentResult, currencySymbol }) => {
    const columns: ExtendedGridColDef[] = [
        {
            field: 'paymentId',
            headerName: 'Odeme Id',
            width: 100,
            renderCell: (params) => {
                return (
                    <Tooltip title={<h1>{params.row.paymentId}</h1>}>
                        <div>{params.row.paymentId}</div>
                    </Tooltip>
                );
            },
        },
        {
            field: 'createDate',
            headerName: 'Oluşturulma Tarihi',
            flex: 1,
            renderCell: (params) => {
                return <div>{TimeHelper.formatDateHourSecond(params.row.createDate)}</div>;
            },
        },
        {
            field: 'completeDate',
            headerName: 'Tamamlanma Tarihi',
            flex: 1,
            renderCell: (params) => {
                return <div>{TimeHelper.formatDateHourSecond(params.row.completeDate)}</div>;
            },
        },
        {
            field: 'paymentAmount',
            headerName: 'Beklenen Tutar',
            width: 150,
            renderCell: (params) => {
                return (
                    <Tooltip
                        title={
                            <h1>
                                {Helper.formatNumber(params.row.paymentAmount)} {currencySymbol}
                            </h1>
                        }
                    >
                        <div>
                            {Helper.formatNumber(params.row.paymentAmount)} {currencySymbol}
                        </div>
                    </Tooltip>
                );
            },
        },
        {
            field: 'confirmedAmount',
            headerName: 'Ödeme Tutarı',
            width: 200,
            renderCell: (params) => {
                return (
                    <Tooltip
                        title={
                            <h1>
                                {Helper.formatNumber(params.row.confirmedAmount)} {currencySymbol}
                            </h1>
                        }
                    >
                        <div>
                            {Helper.formatNumber(params.row.confirmedAmount)} {currencySymbol}
                        </div>
                    </Tooltip>
                );
            },
        },

        {
            field: 'paymentMethodName',
            headerName: 'Ödeme Şekli',
            flex: 1,
            renderCell: (params) => {
                return (
                    <Tooltip title={<h1>{params.row.paymentMethodName}</h1>}>
                        <div>{params.row.paymentMethodName}</div>
                    </Tooltip>
                );
            },
        },
        {
            field: 'paymentStatusName',
            headerName: 'Durum',
            flex: 1,
            renderCell: (params) => {
                return (
                    <Tooltip title={<h1>{params.row.paymentStatusName}</h1>}>
                        <div>{params.row.paymentStatusName}</div>
                    </Tooltip>
                );
            },
        },
    ];

    return (
        <>
            <Grid
                size={{
                    sm: 12,
                    md: 6,
                    lg: 4,
                    xl: 3,
                }}
            ></Grid>
            {paymentResult ? <SCUICustomDataGrid randomId rows={paymentResult} columns={columns} /> : <SCUILoading />}
        </>
    );
};
